import { MedicalType } from "@qendo/medical/types";
import { OptionType } from "@qendo/types";
import { Stack, useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { View } from "react-native";
import { DeleteMedicalButton } from "~/components/form/health-profile/DeleteMedicalButton";
import { HeaderButton } from "~/components/HeaderButton";
import { DataList } from "~/components/layout/DataList";
import { DataListItem } from "~/components/layout/DataListItem";
import { BasicGallery } from "~/components/layout/gallery/BasicGallery";
import { Page } from "~/components/layout/Page";
import { Title } from "~/components/layout/text";
import { Authorize } from "~/components/permission/Authorize";
import { Can } from "~/components/permission/Can";
import { Dismiss } from "~/components/permission/Dismiss";
import { Flex, Gap, Items, Padding } from "~/constants/layout";
import { useMedical } from "~/providers/MedicalProvider";
import { useOptions } from "~/providers/OptionsProvider";
import { filled } from "~/util";
import { formatShortDateForHumans } from "~/util/dates";

const type = MedicalType.immunisation;

export default function ImmunisationDetails() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { findOption } = useOptions();
    const immunisation = useMemo(() => findMedical(type, id), [id, findMedical]);

    if (!immunisation) {
        return <Dismiss />;
    }

    const option = findOption(OptionType.immunisations, immunisation.option_id);

    return (
        <Authorize ability="view" section="immunisations">
            <Stack.Screen
                options={{
                    title: "Immunisation details",
                    headerRight: () => (
                        <Can ability="update" section="immunisations">
                            <HeaderButton
                                title="Edit"
                                href={{ pathname: "/health-profile/immunisations/[id]/edit", params: { id } }}
                            />
                        </Can>
                    ),
                }}
            />
            <Page spacer>
                <View style={[Padding.top_md, Gap.lg, Flex.flex]}>
                    <View style={[Items.start, Gap.xs]}>
                        {filled(option) && <Title size="xl">{option?.title}</Title>}
                    </View>
                    <DataList>
                        <DataListItem
                            title="Date of vaccination"
                            data={
                                immunisation.immunisation_date &&
                                formatShortDateForHumans(immunisation.immunisation_date)
                            }
                        />
                    </DataList>
                    <BasicGallery images={immunisation.photograph_ids} />
                </View>
                <DeleteMedicalButton type={type} id={id} />
            </Page>
        </Authorize>
    );
}
